import { render, staticRenderFns } from "./ClientNavBar.vue?vue&type=template&id=5fe68b64&scoped=true&"
import script from "./ClientNavBar.vue?vue&type=script&lang=js&"
export * from "./ClientNavBar.vue?vue&type=script&lang=js&"
import style0 from "./ClientNavBar.vue?vue&type=style&index=0&id=5fe68b64&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe68b64",
  null
  
)

export default component.exports